import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzg45qwkzz: FaireProductEntity = {
  token: "p_bzg45qwkzz",
  type: "product",
  name: "Treble Clef Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6db41436ad220f49a8c55f753396f24d88c09bc89e41bc8c37d54fcfccffe5e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0fd8e147ed36819a8837b9dcfa14a9fe8fbd76d478ddc58c415f4d4996f46736.jpeg",
    "https://cdn.faire.com/fastly/6278be8d5d09d509fa69b57ea67ef7476ca10d5cfa3faa11c78e99387ffb7b58.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:45.445Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
